import { ROUTES } from "routes/routes";
import TagStatus from "components/TagStatus";
import { useNavigate } from "react-router-dom";
import { Icon } from "@utp/react-components-prod";

interface IHeaderEvaluation {
  isMinorTablet: boolean;
  title: string;
}
const HeaderEvaluation = ({ isMinorTablet,title }: IHeaderEvaluation) => {
  const navigate = useNavigate();
  const handleRedirectToSummary = () => {
    navigate(ROUTES.candidate.summary);
  };
  return (
    <div className="h-56 bg-02 flex items-center px-8 max-w-base m-auto">
      <div className="text-color-02 text-small-02 font-bold flex items-center">
        <button
          className="text-color-primary flex flex-row cursor-pointer items-center focus:bg-red-30 p-1 rounded-sm"
          onClick={() => handleRedirectToSummary()}
        >
          <Icon iconName="arrow-left" size={16} className="mr-2" />
          <span className={isMinorTablet ? "hidden" : "block"}>Salir</span>
        </button>
        <div className="h-8 w-px bg-mid-grey-30 mx-5"></div>
        <span className="flex items-center gap-4">
          {title} <TagStatus type={"IN_PROGRESS"} />{" "}
        </span>
      </div>
    </div>
  );
};

export default HeaderEvaluation;
